
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {ApplicationActions, EditDocumentSeedRequest, EditInlandVesselCertificateSeedRequest, InlandVesselDocumentApiModel, ResultError} from "@/api-client";
    import IssueDocumentInnerComponent from "@/features/applications/components/issue-document/IssueDocumentInnerComponent";
    import IssueDocumentSignature from "@/features/applications/components/issue-document/IssueDocumentSignature.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";

    @Component({
        components: {
            AdditionalInfoButton,
            DatePicker,
            IssueDocumentSignature,
            LabelOptional,
        }
    })
    export default class IssueInlandVesselCertificate extends IssueDocumentInnerComponent {
        @Prop({required: true})
        issueDocumentDetails!: InlandVesselDocumentApiModel
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        errors!: ResultError;
        
        initialEditModel!: EditDocumentSeedRequest;

        additionalInfo = this.issueDocumentDetails.additionalInfo;
        issueDate = this.issueDocumentDetails.issueDate;
        
        mounted() {
            this.initialEditModel = this.getEditModel();
        }

        getEditModel(): EditDocumentSeedRequest {
            return new EditInlandVesselCertificateSeedRequest({additionalInfo: this.additionalInfo, issueDate: this.issueDate})
        }
    }
